/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {object}
     * @memberof Notification
     */
    readonly data?: object;
    /**
     * 
     * @type {Date}
     * @memberof Notification
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Notification
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    readonly title?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    readonly body?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    readonly deepLink?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    readonly icon?: string;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    status?: NotificationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    readonly type?: NotificationTypeEnum;
}

export function NotificationFromJSON(json: any): Notification {
    return NotificationFromJSONTyped(json, false);
}

export function NotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Notification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'body': !exists(json, 'body') ? undefined : json['body'],
        'deepLink': !exists(json, 'deepLink') ? undefined : json['deepLink'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function NotificationToJSON(value?: Notification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}

/**
* @export
* @enum {string}
*/
export enum NotificationStatusEnum {
    Created = 'created',
    Shipped = 'shipped',
    Received = 'received',
    Read = 'read'
}
/**
* @export
* @enum {string}
*/
export enum NotificationTypeEnum {
    Information = 'information',
    Promo = 'promo',
    DealStage = 'deal_stage',
    DealStatus = 'deal_status',
    DealUpdated = 'deal_updated',
    DealDocuments = 'deal_documents',
    BookingUpdated = 'booking_updated',
    BookingStatus = 'booking_status'
}


